<span id="snackbar-text">{{message}}</span>
<span id="snackbar-action" (click)="dismiss()">{{action}}</span>
